import React from "react";

import { createContext, useState } from "react";

export const SidebarContext = createContext();
export const SidebarContextConsumer = SidebarContext.Consumer;

const SidebarContextProvider = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);
  const closeSidebar = () => setIsSidebarCollapsed(false);

  return (
    <SidebarContext.Provider
      value={{ toggleSidebar, closeSidebar, isSidebarCollapsed }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarContextProvider;

function useSidebarContext() {
  const context = React.useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebarContext must be used within a SidebarProvider");
  }
  return context;
}
export { useSidebarContext };
